// import React, { useEffect, useState } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import axios from 'axios';
// import { Col, Row, Table, Badge, Button, Card } from 'react-bootstrap';
// import { BASE_URL } from '../../../services/Api';
// import { authHeader } from '../../../services/auth-header';

// function ViewPumpDomesticSO() {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const [isLoading, setIsLoading] = useState(true);
//   const [salesOrder, setSalesOrder] = useState(null);

//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-IN');
//   };

//   const formatCurrency = (amount) => {
//     if (amount === null || amount === undefined) return '-';
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   const getStatusBadge = (status) => {
//     switch (status) {
//       case 'Draft': return <Badge bg="secondary">Draft</Badge>;
//       case 'Open': return <Badge bg="primary">Open</Badge>;
//       case 'Completed': return <Badge bg="success">Completed</Badge>;
//       case 'Cancelled': return <Badge bg="danger">Cancelled</Badge>;
//       default: return <Badge bg="warning">Unknown</Badge>;
//     }
//   };

//   const getAddressString = (address) => {
//     if (!address) return '-';
//     return [
//       address.customeraddress,
//       address.city?.cityname,
//       address.state?.statename,
//       address.pincode,
//       address.country?.countryname
//     ].filter(Boolean).join(', ');
//   };

//   useEffect(() => {
//     const fetchSalesOrder = async () => {
//       try {
//         const response = await axios.get(`${BASE_URL}salesOrder/findById/${id}`, {
//           headers: authHeader(),
//         });
//         setSalesOrder(response.data);
//       } catch (error) {
//         console.error("Error fetching sales order:", error);
//         Swal.fire("Error", "Failed to load sales order data", "error");
//         navigate("/salesorderindex/1");
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchSalesOrder();
//   }, [id, navigate]);

//   if (isLoading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (!salesOrder) {
//     return (
//       <div className="container mt-4">
//         <div className="alert alert-danger">Sales order not found</div>
//       </div>
//     );
//   }

//   return (
//     <div className="container-fluid mt-3">

//       {/* Basic Order Information */}
//       <Card className="mb-4">
//         <Card.Header>
//           <h5 className="mb-0">Order Information</h5>
//         </Card.Header>
//         <Card.Body>
//           <Row>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">SO Number</label>
//                 <div className="border-bottom pb-1">{salesOrder.sono}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">SO Date</label>
//                 <div className="border-bottom pb-1">{formatDate(salesOrder.sodate)}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Status</label>
//                 <div className="border-bottom pb-1">{getStatusBadge(salesOrder.status)}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Order Type</label>
//                 <div className="border-bottom pb-1">{salesOrder.salesordertype || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Order Category</label>
//                 <div className="border-bottom pb-1">{salesOrder.salesordercategory || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Amendment No.</label>
//                 <div className="border-bottom pb-1">{salesOrder.amendmentno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Amendment Date</label>
//                 <div className="border-bottom pb-1">{formatDate(salesOrder.amendmentdate)}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Quotation No.</label>
//                 <div className="border-bottom pb-1">{salesOrder.quotationno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Quotation Date</label>
//                 <div className="border-bottom pb-1">{formatDate(salesOrder.quotationdate)}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Customer PO No.</label>
//                 <div className="border-bottom pb-1">{salesOrder.customerpono || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Customer PO Date</label>
//                 <div className="border-bottom pb-1">{formatDate(salesOrder.customerpodate)}</div>
//               </div>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>
//       <Card className="mb-4">
//         <Card.Header>
//           <h5 className="mb-0">Additional Information</h5>
//         </Card.Header>
//         <Card.Body>
//           <div className="mb-3">
//             <label className="form-label fw-bold">Customer Material Code</label>
//             <div className="border-bottom pb-1">{salesOrder.customermaterialcode || '-'}</div>
//           </div>
//           <div className="mb-3">
//             <label className="form-label fw-bold">Delivery Term</label>
//             <div className="border-bottom pb-1">{salesOrder.deliveryterm || '-'}</div>
//           </div>
//           <div className="mb-3">
//             <label className="form-label fw-bold">LD Clause</label>
//             <div className="border p-2 rounded bg-light">
//               {salesOrder.ldclause || '-'}
//             </div>
//           </div>
//         </Card.Body>
//       </Card>

//       {/* Complete Customer Information */}
//       <Card className="mb-4">
//         <Card.Header>
//           <h5 className="mb-0">Customer Information</h5>
//         </Card.Header>
//         <Card.Body>
//           <Row>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Customer Name</label>
//                 <div>{salesOrder.customer?.companyname || '-'}</div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">GST No.</label>
//                 <div>{salesOrder.customer?.gstno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Contact Person</label>
//                 <div>{salesOrder.contactperson || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Phone</label>
//                 <div>{salesOrder.contactno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Email</label>
//                 <div>{salesOrder.email || '-'}</div>
//               </div>
//             </Col>
//             <Col md={12}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Address</label>
//                 <div className="border p-2 rounded bg-light">
//                   {getAddressString(salesOrder.customeraddress) || '-'}
//                 </div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Payment Term</label>
//                 <div>{salesOrder.paymentterm || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Freight</label>
//                 <div>{salesOrder.freight || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Packing & Forwarding</label>
//                 <div>{salesOrder.packingandforwarding || '-'}</div>
//               </div>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* Complete Branch Information */}
//       <Card className="mb-4">
//         <Card.Header>
//           <h5 className="mb-0">Branch Information</h5>
//         </Card.Header>
//         <Card.Body>
//           <Row>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Branch Name</label>
//                 <div>{salesOrder.branch?.branchname || '-'}</div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Branch GST</label>
//                 <div>{salesOrder.branch?.gstno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Contact Person</label>
//                 <div>{salesOrder.branch?.contactperson || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Phone</label>
//                 <div>{salesOrder.branch?.phoneno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Email</label>
//                 <div>{salesOrder.branch?.email || '-'}</div>
//               </div>
//             </Col>
//             <Col md={12}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Address</label>
//                 <div className="border p-2 rounded bg-light">
//                   {[
//                     salesOrder.branch?.address,
//                     salesOrder.branch?.city,
//                     salesOrder.branch?.state?.statename,
//                     salesOrder.branch?.zipcode,
//                     salesOrder.branch?.country?.countryname
//                   ].filter(Boolean).join(', ')}
//                 </div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Bank Name</label>
//                 <div>{salesOrder.branch?.bankname || '-'}</div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Account Number</label>
//                 <div>{salesOrder.branch?.accountno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">IFSC Code</label>
//                 <div>{salesOrder.branch?.ifsccode || '-'}</div>
//               </div>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* Complete Warehouse Information */}
//       <Card className="mb-4">
//         <Card.Header>
//           <h5 className="mb-0">Warehouse Information</h5>
//         </Card.Header>
//         <Card.Body>
//           <Row>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Warehouse Name</label>
//                 <div>{salesOrder.warehouse?.warehousename || '-'}</div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Warehouse Type</label>
//                 <div>{salesOrder.warehouse?.warehousetype || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Contact Person</label>
//                 <div>{salesOrder.warehouse?.contactperson || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Phone</label>
//                 <div>{salesOrder.warehouse?.mobileno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Email</label>
//                 <div>{salesOrder.warehouse?.email || '-'}</div>
//               </div>
//             </Col>
//             <Col md={12}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Address</label>
//                 <div className="border p-2 rounded bg-light">
//                   {[
//                     salesOrder.warehouse?.address,
//                     salesOrder.warehouse?.city,
//                     salesOrder.warehouse?.state?.statename,
//                     salesOrder.warehouse?.zipcode,
//                     salesOrder.warehouse?.country?.countryname
//                   ].filter(Boolean).join(', ')}
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* Products Table */}
//       <Card className="mb-4">
//         <Card.Header>
//           <h5 className="mb-0">Order Items</h5>
//         </Card.Header>
//         <Card.Body>
//           <div className="table-responsive">
//             <Table striped bordered hover>
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Description</th>
//                   <th>Part No.</th>
//                   <th>HSN</th>
//                   <th>Qty</th>
//                   <th>UOM</th>
//                   <th>Unit Price</th>
//                   <th>Amount</th>
//                   <th>GST %</th>
//                   <th>Total</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {salesOrder.salesOrderItems?.map((item, index) => (
//                   <tr key={index}>
//                     <td>{index + 1}</td>
//                     <td>{item.product?.description || '-'}</td>
//                     <td>{item.partno || '-'}</td>
//                     <td>{item.hsnsacno || '-'}</td>
//                     <td >{item.quantity}</td>
//                     <td>{item.uom || '-'}</td>
//                     <td >{formatCurrency(item.unitrateinr)}</td>
//                     <td >{formatCurrency(item.amount)}</td>
//                     <td>{item.gst}</td>
//                     <td >{formatCurrency(item.totalinr)}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>
//         </Card.Body>
//       </Card>

//       {/* Additional Charges */}
//       {salesOrder.additionalCharges?.length > 0 && (
//         <Card className="mb-4">
//           <Card.Header>
//             <h5 className="mb-0">Additional Charges</h5>
//           </Card.Header>
//           <Card.Body>
//             <div className="table-responsive">
//               <Table striped bordered hover>
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Charge Type</th>
//                     <th>Amount</th>
//                     <th>GST %</th>
//                     <th>Total</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {salesOrder.additionalCharges.map((charge, index) => (
//                     <tr key={index}>
//                       <td>{index + 1}</td>
//                       <td>{charge.chargetype}</td>
//                       <td >{formatCurrency(charge.chargeamount)}</td>
//                       <td>{charge.chargegst}</td>
//                       <td >{formatCurrency(charge.chargetotal)}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//           </Card.Body>
//         </Card>
//       )}

//       {/* Order Summary at Bottom */}
//       <Card className="mb-4">
//         <Card.Header>
//           <h5 className="mb-0">Order Summary</h5>
//         </Card.Header>
//         <Card.Body>
//           <div className="border p-3 bg-light rounded">
//             <div className="d-flex justify-content-between mb-2">
//               <span className="fw-bold">Products Total:</span>
//               <span className="fw-bold">{formatCurrency(salesOrder.nettotalproduct)}</span>
//             </div>
//             {salesOrder.additionalCharges?.length > 0 && (
//               <div className="d-flex justify-content-between mb-2">
//                 <span className="fw-bold">Additional Charges:</span>
//                 <span className="fw-bold">{formatCurrency(salesOrder.additionalchargestotal)}</span>
//               </div>
//             )}
//             <div className="d-flex justify-content-between mb-2 border-top pt-2">
//               <span className="fw-bold">Gross Total:</span>
//               <span className="fw-bold">{formatCurrency(salesOrder.grosstotal)}</span>
//             </div>
//             <div className="d-flex justify-content-between border-top pt-2">
//               <span className="fw-bold fs-5">Grand Total:</span>
//               <span className="fw-bold fs-5">{formatCurrency(salesOrder.grandtotalproduct)}</span>
//             </div>
//           </div>
//         </Card.Body>
//       </Card>

//       <div className="d-flex justify-content-end mt-3 mb-4">
//         <Button variant="secondary" onClick={() => navigate(-1)}>
//           <i className="bi bi-arrow-left me-2"></i>Back to List
//         </Button>
//       </div>
//     </div>
//   );
// }

// export default ViewPumpDomesticSO;




import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import { Col, Row, Table, Badge, Card, Spinner, Container } from 'react-bootstrap';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';
import { FaArrowLeft } from 'react-icons/fa';

function ViewPumpDomesticSO() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [salesOrder, setSalesOrder] = useState(null);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN');
  };

  const formatCurrency = (value) =>
    new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
    }).format(value || 0);

  const getStatusBadge = (status) => {
    switch (status) {
      case 'Draft': return 'secondary';
      case 'Open': return 'primary';
      case 'Completed': return 'success';
      case 'Cancelled': return 'danger';
      default: return 'warning';
    }
  };

  const getAddressString = (address) => {
    if (!address) return '-';
    return [
      address.customeraddress,
      address.city?.cityname,
      address.state?.statename,
      address.pincode,
      address.country?.countryname
    ].filter(Boolean).join(', ');
  };

  useEffect(() => {
    const fetchSalesOrder = async () => {
      try {
        const response = await axios.get(`${BASE_URL}salesOrder/findById/${id}`, {
          headers: authHeader(),
        });
        setSalesOrder(response.data);
      } catch (error) {
        console.error("Error fetching sales order:", error);
        Swal.fire("Error", "Failed to load sales order data", "error");
        navigate("/salesorderindex/1");
      } finally {
        setIsLoading(false);
      }
    };

    fetchSalesOrder();
  }, [id, navigate]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!salesOrder) {
    return <div className="alert alert-danger text-center mt-4">Sales order not found</div>;
  }

  return (
    <Container fluid className="p-3">
      {/* Header Section */}
      <Card className="shadow-sm border-0 rounded mb-3">
        <Card.Body className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="fw-bold text-primary mb-0">SALES ORDER - VIEW</h5>
            <button className="btn btn-secondary btn-sm" onClick={() => navigate(-1)}>
              <FaArrowLeft className="me-1" />
              Back
            </button>
          </div>
          
          <Row className="g-2">
            <Col md={3}>
              <div className="border-start border-3 border-primary ps-2">
                <small className="text-muted">SO Number</small>
                <div className="fw-bold">{salesOrder.sono}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-success ps-2">
                <small className="text-muted">SO Date</small>
                <div className="fw-bold">{formatDate(salesOrder.sodate)}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-warning ps-2">
                <small className="text-muted">Customer PO No</small>
                <div className="fw-bold">{salesOrder.customerpono || '-'}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-info ps-2">
                <small className="text-muted">Status</small>
                <div>
                  <Badge 
                    bg={getStatusBadge(salesOrder.status)} 
                    className="px-2 py-1"
                  >
                    {salesOrder.status || '-'}
                  </Badge>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Order Information */}
      <Card className="shadow-sm border-0 rounded mb-3">
        <Card.Header className="bg-light py-2">
          <h6 className="mb-0 fw-bold">Order Information</h6>
        </Card.Header>
        <Card.Body className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Order Type</small>
                <div className="fw-bold">{salesOrder.salesordertype || '-'}</div>
              </div>
              <div>
                <small className="text-muted">Order Category</small>
                <div className="fw-bold">{salesOrder.salesordercategory || '-'}</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Quotation No</small>
                <div className="fw-bold">{salesOrder.quotationno || '-'}</div>
              </div>
              <div>
                <small className="text-muted">Quotation Date</small>
                <div className="fw-bold">{formatDate(salesOrder.quotationdate)}</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Amendment No</small>
                <div className="fw-bold">{salesOrder.amendmentno || '-'}</div>
              </div>
              <div>
                <small className="text-muted">Amendment Date</small>
                <div className="fw-bold">{formatDate(salesOrder.amendmentdate)}</div>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-2">
                <small className="text-muted">Customer Material Code</small>
                <div className="fw-bold">{salesOrder.customermaterialcode || '-'}</div>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-2">
                <small className="text-muted">Delivery Term</small>
                <div className="fw-bold">{salesOrder.deliveryterm || '-'}</div>
              </div>
            </Col>
            <Col md={12}>
              <div className="mt-2">
                <small className="text-muted">LD Clause</small>
                <div className="fw-bold">{salesOrder.ldclause || '-'}</div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Customer Information */}
      <Card className="shadow-sm border-0 rounded mb-3">
        <Card.Header className="bg-light py-2">
          <h6 className="mb-0 fw-bold">Customer Information</h6>
        </Card.Header>
        <Card.Body className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Company Name</small>
                <div className="fw-bold">{salesOrder.customer?.companyname || '-'}</div>
              </div>
              <div>
                <small className="text-muted">GST No</small>
                <div className="fw-bold">{salesOrder.customer?.gstno || '-'}</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Contact Person</small>
                <div className="fw-bold">{salesOrder.contactperson || '-'}</div>
              </div>
              <div>
                <small className="text-muted">Phone</small>
                <div className="fw-bold">{salesOrder.contactno || '-'}</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Email</small>
                <div className="fw-bold">{salesOrder.email || '-'}</div>
              </div>
              <div>
                <small className="text-muted">Payment Term</small>
                <div className="fw-bold">{salesOrder.paymentterm || '-'}</div>
              </div>
            </Col>
            <Col md={12}>
              <div className="mt-2">
                <small className="text-muted">Address</small>
                <div className="fw-bold">{getAddressString(salesOrder.customeraddress) || '-'}</div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Branch & Warehouse Information */}
      <Row className="mb-3">
        <Col md={6}>
          <Card className="shadow-sm border-0 rounded h-100">
            <Card.Header className="bg-light py-2">
              <h6 className="mb-0 fw-bold">Branch Information</h6>
            </Card.Header>
            <Card.Body className="p-3">
              <Row className="g-3">
                <Col md={6}>
                  <div className="mb-2">
                    <small className="text-muted">Branch Name</small>
                    <div className="fw-bold">{salesOrder.branch?.branchname || '-'}</div>
                  </div>
                  <div>
                    <small className="text-muted">Branch GST</small>
                    <div className="fw-bold">{salesOrder.branch?.gstno || '-'}</div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-2">
                    <small className="text-muted">Contact Person</small>
                    <div className="fw-bold">{salesOrder.branch?.contactperson || '-'}</div>
                  </div>
                  <div>
                    <small className="text-muted">Phone</small>
                    <div className="fw-bold">{salesOrder.branch?.phoneno || '-'}</div>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="mt-2">
                    <small className="text-muted">Address</small>
                    <div className="fw-bold">
                      {[
                        salesOrder.branch?.address,
                        salesOrder.branch?.city,
                        salesOrder.branch?.state?.statename,
                        salesOrder.branch?.zipcode,
                        salesOrder.branch?.country?.countryname
                      ].filter(Boolean).join(', ')}
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="shadow-sm border-0 rounded h-100">
            <Card.Header className="bg-light py-2">
              <h6 className="mb-0 fw-bold">Warehouse Information</h6>
            </Card.Header>
            <Card.Body className="p-3">
              <Row className="g-3">
                <Col md={6}>
                  <div className="mb-2">
                    <small className="text-muted">Warehouse Name</small>
                    <div className="fw-bold">{salesOrder.warehouse?.warehousename || '-'}</div>
                  </div>
                  <div>
                    <small className="text-muted">Warehouse Type</small>
                    <div className="fw-bold">{salesOrder.warehouse?.warehousetype || '-'}</div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-2">
                    <small className="text-muted">Contact Person</small>
                    <div className="fw-bold">{salesOrder.warehouse?.contactperson || '-'}</div>
                  </div>
                  <div>
                    <small className="text-muted">Phone</small>
                    <div className="fw-bold">{salesOrder.warehouse?.mobileno || '-'}</div>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="mt-2">
                    <small className="text-muted">Address</small>
                    <div className="fw-bold">
                      {[
                        salesOrder.warehouse?.address,
                        salesOrder.warehouse?.city,
                        salesOrder.warehouse?.state?.statename,
                        salesOrder.warehouse?.zipcode,
                        salesOrder.warehouse?.country?.countryname
                      ].filter(Boolean).join(', ')}
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Order Items */}
      <Card className="shadow-sm border-0 rounded mb-3">
        <Card.Header className="bg-light py-2">
          <h6 className="mb-0 fw-bold">Order Items</h6>
        </Card.Header>
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table bordered size="sm" className="mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center fw-bold py-2">#</th>
                  <th className="fw-bold py-2">Description</th>
                  <th className="fw-bold py-2">Part No</th>
                  <th className="fw-bold py-2">HSN Code</th>
                  <th className="fw-bold py-2 text-center">Qty</th>
                  <th className="fw-bold py-2 text-center">UOM</th>
                  <th className="fw-bold py-2 text-end">Unit Price</th>
                  <th className="fw-bold py-2 text-end">Amount</th>
                  <th className="fw-bold py-2 text-center">GST %</th>
                  <th className="fw-bold py-2 text-end">Total</th>
                </tr>
              </thead>
              <tbody>
                {salesOrder.salesOrderItems?.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td className="fw-semibold">{item.product?.description || '-'}</td>
                    <td>{item.partno || '-'}</td>
                    <td>{item.hsnsacno || '-'}</td>
                    <td className="text-center">{item.quantity}</td>
                    <td className="text-center">{item.uom || '-'}</td>
                    <td className="text-end">{formatCurrency(item.unitrateinr)}</td>
                    <td className="text-end">{formatCurrency(item.amount)}</td>
                    <td className="text-center">{item.gst}%</td>
                    <td className="text-end fw-bold">{formatCurrency(item.totalinr)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table-light">
                <tr>
                  <td colSpan="9" className="text-end fw-bold py-2">
                    Products Total:
                  </td>
                  <td className="text-end fw-bold py-2">
                    {formatCurrency(salesOrder.nettotalproduct)}
                  </td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </Card.Body>
      </Card>

      {/* Additional Charges */}
      {salesOrder.additionalCharges?.length > 0 && (
        <Card className="shadow-sm border-0 rounded mb-3">
          <Card.Header className="bg-light py-2">
            <h6 className="mb-0 fw-bold">Additional Charges</h6>
          </Card.Header>
          <Card.Body className="p-0">
            <div className="table-responsive">
              <Table bordered size="sm" className="mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="fw-bold py-2">#</th>
                    <th className="fw-bold py-2">Charge Type</th>
                    <th className="fw-bold py-2 text-end">Amount</th>
                    <th className="fw-bold py-2 text-center">GST %</th>
                    <th className="fw-bold py-2 text-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {salesOrder.additionalCharges.map((charge, index) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td>{charge.chargetype}</td>
                      <td className="text-end">{formatCurrency(charge.chargeamount)}</td>
                      <td className="text-center">{charge.chargegst}%</td>
                      <td className="text-end fw-bold">{formatCurrency(charge.chargetotal)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="table-light">
                  <tr>
                    <td colSpan="4" className="text-end fw-bold py-2">
                      Charges Total:
                    </td>
                    <td className="text-end fw-bold py-2">
                      {formatCurrency(salesOrder.additionalchargestotal)}
                    </td>
                  </tr>
                </tfoot>
              </Table>
            </div>
          </Card.Body>
        </Card>
      )}

      {/* Summary Section */}
      <Row>
        <Col lg={6} className="ms-auto">
          <Card className="shadow-sm border-0 rounded">
            <Card.Header className="bg-light py-2">
              <h6 className="mb-0 fw-bold text-center">Order Summary</h6>
            </Card.Header>
            <Card.Body className="p-3">
              <div className="space-y-2">
                <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                  <span className="fw-semibold">Products Total:</span>
                  <span className="fw-bold">{formatCurrency(salesOrder.nettotalproduct)}</span>
                </div>
                
                {salesOrder.additionalCharges?.length > 0 && (
                  <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                    <span className="fw-semibold">Additional Charges:</span>
                    <span className="fw-bold">{formatCurrency(salesOrder.additionalchargestotal)}</span>
                  </div>
                )}

                <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                  <span className="fw-semibold">Gross Total:</span>
                  <span className="fw-bold">{formatCurrency(salesOrder.grosstotal)}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center py-2 border-top">
                  <span className="fw-bold">Grand Total</span>
                  <span className="fw-bold text-primary">{formatCurrency(salesOrder.grandtotalproduct)}</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Footer Actions */}
      <div className="text-center mt-3 pt-2 border-top">
        <button 
          className="btn btn-secondary btn-sm"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft className="me-1" />
          Back to List
        </button>
      </div>
    </Container>
  );
}

export default ViewPumpDomesticSO;